import React from "react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { ArrowRight, Sparkles } from "lucide-react";
import { motion } from "framer-motion";
import { useIsMobile } from "@/hooks/use-mobile";

const MobileHeroCard = () => {
  const isMobile = useIsMobile();

  if (!isMobile) {
    return null;
  }

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      className="mx-4 mt-3"
    >
      <div className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-jamaica-green to-jamaica-yellow p-6 shadow-lg">
        {/* Content */}
        <div className="relative z-10 text-white">
          <div className="flex items-center gap-2 mb-3">
            <span className="text-sm font-medium opacity-90">🇯🇲 JamPack'd from Yaad 🇯🇲</span>
          </div>
          
          <h3 className="text-xl font-bold mb-2 leading-tight font-display">
            Authentic Jamaican Experience
          </h3>
          
          <p className="text-sm opacity-90 mb-4 leading-relaxed">
            Premium care packages with authentic snacks, spices, and cultural treasures from Jamaica.
          </p>
          
          <Button 
            size="sm" 
            className="bg-white text-jamaica-green hover:bg-white/90 font-semibold"
          >
            <Link to="/products" className="flex items-center gap-2">
              Shop Now
              <ArrowRight className="w-4 h-4" />
            </Link>
          </Button>
        </div>

        {/* Subtle pattern overlay */}
        <div 
          className="absolute inset-0 opacity-10"
          style={{
            backgroundImage: "radial-gradient(circle at 20% 80%, white 1px, transparent 1px), radial-gradient(circle at 80% 20%, white 1px, transparent 1px)",
            backgroundSize: "30px 30px"
          }}
        />
      </div>
    </motion.div>
  );
};

export default MobileHeroCard;